import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { LanguageService } from '../../shared/services/language.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const authService = inject(AuthService);
  const languageService = inject(LanguageService);
  const token = authService.getToken();
  const currentLang = languageService.currentLanguage();

  // Build headers with Accept-Language
  const headers: Record<string, string> = {
    'Accept-Language': currentLang,
  };

  // Skip adding token for non-API requests or auth endpoints
  if (!req.url.startsWith(environment.apiUrl) || isAuthEndpoint(req.url)) {
    // Still add Accept-Language for all API requests
    if (req.url.startsWith(environment.apiUrl)) {
      const langReq = req.clone({ setHeaders: headers });
      return next(langReq);
    }
    return next(req);
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const modifiedReq = req.clone({ setHeaders: headers });
  return next(modifiedReq);
};

function isAuthEndpoint(url: string): boolean {
  const authEndpoints = ['/Auth/login'];
  return authEndpoints.some((endpoint) => url.toLowerCase().includes(endpoint.toLowerCase()));
}
